import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'

import useTranslations from '../../../hooks/useTranslations'
import { addressFormat } from '../../../utils'
import { childUsers, userWiseRole } from '../../../utils/constant'
import { pdfImage } from '../../../utils/icons'
import {
  entries,
  include,
  isArray,
  isEqual,
  length,
  notEqual,
  ternary,
} from '../../../utils/javascript'
import { getItem } from '../../../utils/localstorage'
import { getVehicleModelListApi } from '../../jobs/jobs.api'
import { userChildrenList } from '../../layout/sidebar.description'
import { updateUserApi } from '../user.api'
import { departmentOptions, refurbisherMachineTitle } from '../user.description'

const viewUser = ({ userDetails }) => {
  const {
    id,
    businessName,
    displayName,
    emailId,
    phoneNumber,
    contact,
    panNo,
    roleId,
    lastName,
    name,
    parent,
    parentDetails,
    // consumerTags,
    recyclerRvsfCertification,
    certificateNumber,
    certificateDetails,
    gstNumber,
    inchargeName,
    inchargeDetails,
    recyclerAirActDate,
    recyclerWaterActDate,
    recyclerAuthorisationValidityDate,
    recyclerCertificationValidityDate,
    recyclerCategoryDetails,
    materialTypes,
    producerTinNumber,
    producerCpcbCertification,
    departmentName,
    otherDoableJobTags,
  } = {
    ...userDetails,
  }
  const { t } = useTranslations()
  const [loader, setLoader] = useState(false)
  const [vehicleModelData, setVehicleModelData] = useState({ list: [] })
  const parentData = parent || parentDetails
  const currentUser = userChildrenList.find(val => isEqual(val.userId, roleId))
  const userListView = currentUser?.userView
  const loginUserRoleId = JSON.parse(getItem('userData'))?.roleId
  const [reportView, setReportView] = useState({
    isOpen: false,
    reportLink: '',
  })

  const {
    admin,
    consumer,
    consumerUser,
    dealer,
    dealerUser,
    recycler,
    recyclingTechnician,
    refurbisher,
    refurbisherUser,
    trader,
    traderUser,
    supplier,
    supplierUser,
    producer,
    producerUser,
    thirdPartyRecycle,
    thirdPartyRecycleUser,
    disposer,
    disposerUser,
    secondHandBuyer,
    secondHandBuyerUser,
    transporter,
    nationalGov,
    nationalGovUser,
    cpcbGov,
    cpcbGovUser,
    spcbGov,
    spcbGovUser,
    districtGov,
    districtGovUser,
    superUser,
    dataEntry,
    categoryUser,
    salesUser,
    operationsUser,
    scrappingFacilityEntryUser,
    collectionCenter,
  } = userWiseRole
  const allUser = [
    admin,
    consumer,
    consumerUser,
    dealer,
    dealerUser,
    recycler,
    recyclingTechnician,
    refurbisher,
    refurbisherUser,
    trader,
    traderUser,
    supplier,
    supplierUser,
    producer,
    producerUser,
    thirdPartyRecycle,
    thirdPartyRecycleUser,
    disposer,
    disposerUser,
    secondHandBuyer,
    secondHandBuyerUser,
    transporter,
    nationalGov,
    nationalGovUser,
    cpcbGov,
    cpcbGovUser,
    spcbGov,
    spcbGovUser,
    districtGov,
    districtGovUser,
  ]
  const PAGE_SIZE = 15

  useEffect(() => {
    if (isEqual(roleId, producer)) {
      getVehicleModelList({ pageNo: 1 })
    }
  }, [userDetails?.id])

  const getVehicleModelList = async ({ pageNo = 1 }) => {
    if (!userDetails?.id) return

    setVehicleModelData(prev => ({ ...prev, loader: true }))

    const payload = { producerId: userDetails?.id, pageSize: PAGE_SIZE }

    const resp = await getVehicleModelListApi({
      params: payload,
      pageNo,
    })

    setVehicleModelData(prev => ({
      ...resp?.data,
      loader: false,
    }))
  }

  const onVehicleModelPageChange = current => {
    getVehicleModelList({ pageNo: current })
  }

  const updateVehicleModelList = async apiPayload => {
    setLoader(true)
    const payload = {
      userId: userDetails?.id,
      country: userDetails?.country,
      ...apiPayload,
    }

    const response = await updateUserApi({
      payload,
    })
    setLoader(false)

    if (!response?.data?.data?.success) return
    getVehicleModelList({ pageNo: vehicleModelData?.pageNo })
  }

  const handleDeleteModel = id => {
    updateVehicleModelList({
      modelIds: [id],
    })
  }

  const handleSaveModel = modelNames => {
    updateVehicleModelList({
      modelNames,
    })
  }

  const getEmailList = () => {
    const emailList = {}
    entries(userDetails).forEach(([key, value]) => {
      if (include(key, 'email') && value) {
        emailList[key] = value
      }
    })
    delete emailList.emailId
    return emailList
  }

  const viewPdf = ({ url }) => {
    setReportView(prev => ({
      isOpen: !prev?.isOpen,
      reportLink: url,
    }))
  }

  const basicInfoData = [
    { label: 'user_ID', value: id },
    {
      label: 'user_BusinessName',
      value: businessName,
      hidden: include(childUsers, roleId) || !roleId,
    },
    { label: 'user_Name', value: ternary(roleId, lastName, name) },
    {
      label: 'user_DisplayName',
      value: displayName || 'RVSF',
      hidden: !include([recycler], roleId),
    },
    {
      label: 'user_Email',
      value: emailId,
      type: 'email',
    },
    { label: 'user_Contact', value: phoneNumber || contact },
    { label: 'job_PAN', value: panNo, hidden: notEqual(consumer, roleId) },
    {
      label: 'user_Address',
      value: addressFormat(userDetails),
      isBottomLine: true,
    },
    {
      label: 'user_DepartmentName',
      value: departmentName ? t(departmentOptions[departmentName]) : '-',
      hidden: !include(
        [
          superUser,
          dataEntry,
          categoryUser,
          salesUser,
          operationsUser,
          scrappingFacilityEntryUser,
        ],
        roleId,
      ),
    },
  ]

  const plasticMachineDetails = [
    { label: 'txt_TypeOfMachine', value: '', permission: [refurbisher] },
    {
      label: 'txt_EnergySourceElectricityFromGrid',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceElectricityFromRenewable',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceElectricityFromOwnGeneration',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceSolidFuelType',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceSolidFuelQuantity',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceLiquidFuelType',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceLiquidFuelQuantity',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceGaseousFuelType',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceGaseousFuelQuantity',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceBioFuelType',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceBioFuelQuantity',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceOthersFuelType',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceOthersFuelQuantity',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_InputMaterialType',
      value: '',
      permission: [refurbisher],
      hidden: isEqual(roleId, supplier),
    },
    {
      label: 'txt_InputQuantity',
      value: '',
      permission: [refurbisher],
      hidden: isEqual(roleId, supplier),
    },
    {
      label: 'txt_OutputForProductionType',
      value: '',
      permission: [refurbisher],
      hidden: isEqual(roleId, supplier),
    },
    {
      label: 'txt_OutputForProductionQuantity',
      value: '',
      permission: [refurbisher],
      hidden: isEqual(roleId, supplier),
      className: 'border-bottom',
    },
  ].filter(val => !val.hidden)

  const steelMachineDetails = [
    {
      label: 'txt_EnergySourceElectricityFromOwnGeneration',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceSolidFuelType',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceSolidFuelQuantity',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceLiquidFuelType',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceLiquidFuelQuantity',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceGaseousFuelType',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceGaseousFuelQuantity',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceBioFuelType',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceBioFuelQuantity',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceOthersFuelType',
      value: '',
      permission: [refurbisher],
    },
    {
      label: 'txt_EnergySourceOthersFuelQuantity',
      value: '',
      permission: [refurbisher],
      className: 'border-bottom',
    },
  ]

  const parentInfoData = [
    { label: 'user_ID', value: parentData?.id },
    {
      label: 'user_BusinessName',
      value: parentData?.businessName,
      hidden: include(childUsers, roleId),
    },
    { label: 'user_Name', value: parentData?.lastName },
    {
      label: 'user_Email',
      value: parentData?.emailId,
      type: 'email',
    },
    { label: 'user_Contact', value: parentData?.phoneNumber },
    {
      label: 'user_Address',
      value: addressFormat(parentData),
    },
  ]
  const otherDetail = [
    {
      label: 'user_DepartmentName',
      value: departmentName,
      permission: allUser,
      className: isEqual(roleId, recycler) ? 'border-bottom' : '',
    },
    {
      label: 'user_InChargeName',
      value: inchargeName,
      className: 'border-bottom',
      permission: allUser.filter(val => notEqual(val, recycler)),
    },
    {
      label: 'job_MaterialType',
      value: materialTypes
        ?.map(({ materialTypeKey } = {}) => t(materialTypeKey))
        ?.join(', '),
      permission: [refurbisher, supplier],
    },
    {
      label: 'user_DoableJobs',
      value: otherDoableJobTags
        ?.map(item => t(item?.key))
        ?.includes('Part Production') ? (
        <CheckOutlined />
      ) : (
        <CloseOutlined style={{ color: 'red' }} />
      ),
      optionValue: t('job_SupplierProduction'),
      permission: [refurbisher],
      className: 'border-bottom',
    },
    ...(isEqual(roleId, refurbisher) && isArray(materialTypes)
      ? materialTypes
          .filter(val => notEqual(val?.materialTypeKey, 'job_Plastic'))
          .map(val => [
            {
              title: refurbisherMachineTitle[val?.materialTypeKey],
              permission: [refurbisher],
            },
            {
              label: 'user_Type',
              value: t(val?.machineTypeKey),
              permission: [refurbisher],
            },
            {
              label: 'user_Energy',
              value: t(val?.machineEnergyKey),
              permission: [refurbisher],
            },
            {
              label: 'user_CapacityPerHit',
              value: val?.capacity,
              className: 'border-bottom',
              permission: [refurbisher],
            },
          ])
          .flat()
      : []),
    ...(include(['job_Plastic'], materialTypes?.[0]?.materialTypeKey) &&
    isEqual(roleId, refurbisher)
      ? [
          {
            title: 'txt_MachineDetails',
            permission: [refurbisher],
            isTabular: true,
          },
          {
            title: 'txt_Sorting',
            permission: [refurbisher],
            className: 'content-title mb-10 mt-15',
            fields: plasticMachineDetails,
            isTabular: true,
          },
          {
            title: 'txt_Grinding',
            permission: [refurbisher],
            className: 'content-title mb-10 mt-15',
            fields: plasticMachineDetails,
            isTabular: true,
          },
          {
            title: 'txt_PreCompounding',
            permission: [refurbisher],
            className: 'content-title mb-10 mt-15',
            fields: plasticMachineDetails,
            isTabular: true,
          },
          {
            title: 'txt_Compounding',
            permission: [refurbisher],
            className: 'content-title mb-10 mt-15',
            fields: plasticMachineDetails,
            isTabular: true,
          },
        ]
      : []),
    ...(include(['job_Steel'], materialTypes?.[0]?.materialTypeKey) &&
    isEqual(roleId, refurbisher)
      ? [
          {
            title: 'txt_MachineDetails',
            permission: [refurbisher],
            isTabular: true,
          },
          {
            title: 'home_Refurbishment',
            permission: [refurbisher],
            className: 'content-title mb-10 mt-15',
            fields: steelMachineDetails,
            isTabular: true,
          },
          {
            title: 'job_PostMaterialProduction',
            permission: [refurbisher],
            className: 'content-title mb-10 mt-15',
            fields: steelMachineDetails,
            isTabular: true,
          },
        ]
      : []),
    ...(include(
      ['job_Plastic', 'job_Steel'],
      materialTypes?.[0]?.materialTypeKey,
    ) && isEqual(roleId, supplier)
      ? [
          {
            title: 'txt_MachineDetails',
            permission: [refurbisher],
            isTabular: true,
          },
          {
            title: '',
            permission: [refurbisher],
            className: 'content-title mb-10 mt-15',
            fields: plasticMachineDetails,
            isTabular: true,
          },
        ]
      : []),
    // {
    //   label: 'user_SelectionFunctionality',
    //   value: isArray(selectionFunctionality)
    //     ? selectionFunctionality.map(val => t(val)).join(', ')
    //     : '-',
    //   className: 'border-bottom',
    //   permission: [dealer],
    // },
    {
      label: 'user_LocationAndChannel',
      value: (
        <div className="d-inline-block">
          {userDetails?.userLocationChannelDtos?.map(
            ({ locationName, channels, stateName }) => {
              return (
                <div key={locationName}>
                  {stateName ? <span>{stateName} -</span> : ''}
                  <span className="ml-5">{locationName}</span> -
                  <span className="ml-5">
                    {length(channels)
                      ? channels?.map(val => val?.channelKey)?.join(', ')
                      : '-'}
                  </span>
                </div>
              )
            },
          )}
        </div>
      ),
      className: 'border-bottom',
      permission: [dealer, collectionCenter],
    },
    {
      label: 'user_RVSFCertification',
      value: recyclerRvsfCertification ? <CheckOutlined /> : <CloseOutlined />,
      className: 'check-outlined',
      permission: [recycler],
    },
    {
      label: 'user_CertificateNumber',
      value: certificateNumber,
      permission: [recycler],
    },
    {
      label: 'user_CertificateUpload',
      value: certificateDetails?.fileUrl ? (
        <img
          src={pdfImage}
          height={60}
          width={50}
          alt="certificate"
          onClick={() =>
            viewPdf({
              url: certificateDetails?.fileUrl,
            })
          }
        />
      ) : (
        '-'
      ),
      permission: [recycler],
      className: 'cursor-pointer',
    },
    {
      label: 'user_GSTNumber',
      value: gstNumber,
      permission: [recycler],
      className: 'border-bottom',
    },
    {
      label: 'user_AuthorisedPersonName',
      value: inchargeName,
      permission: [recycler],
    },
    {
      label: 'user_AuthorisedPersonEmail',
      value: inchargeDetails?.inchargeEmail,
      permission: [recycler],
    },
    {
      label: 'user_AuthorisedPersonMobileNumber',
      value: inchargeDetails?.inchargePhone,
      permission: [recycler],
      className: 'border-bottom',
    },
    {
      label: 'user_UnderAirAct1981ValidUpTo',
      value: recyclerAirActDate,
      permission: [recycler],
    },
    {
      label: 'user_UnderWaterAct1974ValidUpTo',
      value: recyclerWaterActDate,
      permission: [recycler],
      className: 'border-bottom',
    },
    {
      label:
        'user_ValidityOfAuthorisationUnderRule6OfTheHazardousWastesManagementAndHandlingRules2016',
      value: recyclerAuthorisationValidityDate,
      permission: [recycler],
      className: 'border-bottom',
    },
    {
      label:
        'user_ValidityOfCertificationOfRegistrationWithDistrictIndustriesCentre',
      value: recyclerCertificationValidityDate,
      permission: [recycler],
      className: 'border-bottom',
    },
    {
      label: 'user_RecyclerFormField1',
      value: recyclerCategoryDetails,
      permission: [recycler],
      className: 'border-bottom',
    },
    {
      label: 'user_GSTNumber',
      value: gstNumber,
      permission: [producer],
    },
    {
      label: 'userTINNumber',
      value: producerTinNumber,
      permission: [producer],
      className: 'border-bottom',
    },
    {
      label: 'user_CPCBCertification',
      value: producerCpcbCertification ? <CheckOutlined /> : <CloseOutlined />,
      className: 'check-outlined',
      permission: [producer],
    },
    {
      label: 'user_CertificateNumber',
      value: certificateNumber,
      permission: [producer],
    },
    {
      label: 'user_CertificateUpload',
      value: certificateDetails?.fileUrl ? (
        <img
          src={pdfImage}
          height={60}
          width={50}
          alt="certificate"
          onClick={() =>
            viewPdf({
              url: certificateDetails?.fileUrl,
            })
          }
        />
      ) : (
        '-'
      ),
      permission: [producer],
      className: 'cursor-pointer border-bottom mb-30',
    },
  ]

  return {
    parentData,
    reportView,
    otherDetail,
    userListView,
    basicInfoData,
    parentInfoData,
    loginUserRoleId,
    setReportView,
    getEmailList,
    handleDeleteModel,
    handleSaveModel,
    loader,
    vehicleModelData,
    onVehicleModelPageChange,
    PAGE_SIZE,
  }
}

export default viewUser
